// thunk.js

import { loginSuccess, loginfailure, logout } from "./reducer";
import axios from "axios";
import toast from "react-hot-toast";
import _BaseAPIService from "../../../services/_BaseAPIService";
import { getLoggedInUser } from "../../../helpers/fakebackend_helper";

const apiUrl = window.APP_CONFIG.api1.baseapi + "/auth/login";
const authUser = getLoggedInUser();
console.log("authUserr", authUser);

export const login = (credentials, history) => {
  return async (dispatch) => {
    try {
      const response = await axios.post(apiUrl, credentials);
      const user = response; // ✅ FIXED
      console.log("🚀 ~ login ~ user:", user)

    if (user?.token) {
      _BaseAPIService.storeToken(user.token);
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("token", user.token);

      let savedUsers = JSON.parse(localStorage.getItem("savedUsers")) || [];
      const newUser = {
        user: {
          email: user.user?.email || "superadmin@example.com", // adjust if missing
          roles: user.user?.roles || [user.role] || [],
        },
      };

      const exists = savedUsers.some(
        (item) => item.user.email === newUser.user.email
      );

      if (!exists) {
        savedUsers.push(newUser);
        localStorage.setItem("savedUsers", JSON.stringify(savedUsers));
      }

      dispatch(loginSuccess(user));

      const isSuperAdmin = user.user?.roles?.includes("SuperAdmin") || user.role === "SuperAdmin";
      const isOrgAdmin = user.user?.roles?.includes("OrgAdmin") || user.role === "OrgAdmin";

      // if (isSuperAdmin || isOrgAdmin) {
        history("/dashboard");
      // } else {
      //   history("/pos");
      // }

      toast.success("Welcome to Ordering system");
    } else {
      dispatch(loginfailure());
      // toast.error("Invalid username or password. Please try again.");
    }
  } catch (error) {
    console.error(error);
    dispatch(loginfailure());
    toast.error("Invalid username or password. Please try again.");
  }
};
};

export const logoutUser = () => (dispatch) => {
  // Clear the user data and token from local storage.
  localStorage.removeItem("user");
  localStorage.removeItem("token");
  localStorage.removeItem("lastCalendarView");

  // Dispatch the logout action.
  dispatch(logout());
};
